/* eslint-disable react/prop-types */

import axios from "axios"

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Table from "examples/Tables/Table";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftDatePicker from "components/SoftDatePicker";
import SoftSelect from "components/SoftSelect";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import SoftAvatar from "components/SoftAvatar";
import SoftButton from "components/SoftButton";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PermissionNavbar from "examples/Navbars/PermissionNavbar";
import TimelineItem from "examples/Timeline/TimelineItem";
import ReportsBarChart from "examples/Charts/BarCharts/ReportSkorChart";
import Header from "layouts/headers/NormalHeader"

import PageHeader from "layouts/skor-rapor/Header"

import curved0 from "assets/images/header/IMG_9638.jpg";
import { RowingSharp } from "@mui/icons-material";


function Tables() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [dataHedef, setDataHedef] = useState([]);
  const [dataSkor, setDataSkor] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

  const onTabChange = (index) => {
    if (tabIndex != -1) {
      setTabIndex(index);
    }
  }

  const yearChangeAdd = (index) => {
    navigate("/insan-kaynaklari/yillik-skor/"+ (parseInt(id) + 1));
  }
  const yearChangeRemove = () => {
    navigate("/insan-kaynaklari/yillik-skor/" + (parseInt(id) - 1));
  }


  const currentYear = new Date().getFullYear();

  if (id === ":id") {
    navigate("/insan-kaynaklari/yillik-skor/" + currentYear);
  }

  const [isLoading, setIsLoading] = useState(false);

  const uniqueMudurlukler = [
    ...new Set(
      Object.keys(dataSkor || {}).map(index_paket => dataSkor[index_paket]?.user_info?.mudurluk).filter(Boolean)
    ),
  ];

  const [selectedMudurluk, setSelectedMudurluk] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      //console.log("VERİ")
      try {
        const response = await axios.get(`${window.BASE_URL}/inews-ai/group`, { withCredentials: true });
        setData(response.data);
      } catch (error) {
        console.log(error);

      }
    };

    fetchData();
  }, [id, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      //console.log("VERİ")
      try {
        const response = await axios.get(`${window.BASE_URL}/inews-hedefler`, { withCredentials: true });
        setDataHedef(response.data);
      } catch (error) {
        console.log(error);

      }
    };

    fetchData();
  }, []);



  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(`${window.BASE_URL}/notlar/skorlar/${id}?format=json`, { withCredentials: true });
        setDataSkor(response.data);
      } catch (error) {
        console.log(error);

      }
      finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);


  let dataheader = {
    "title": "Yıllık Skor Raporu",
    "line1": "Bu sayfada, çalışanların yıllık raporları ve hedefleri yer almaktadır.",
    "line2": "",
    "image": curved0,
  }


  try {



    let rows = []

    let items = []
    let same_groups = ""
    let same_ungroups = []
    let ungroup_count = 0
    let ungroup_total = 0
    let used_package = []

    if (data) {


      Object.entries(data).map(index => {
        items = []
        used_package = []


        Object.entries(index[1]).map(index_paket => {
          if (index_paket[0] != "NAME" && index_paket[0] != "TOPLAM" && index_paket[0] != "AY_SAYI" && index_paket[0] != "KISI_SAYISI" && index_paket[0] != "LIST" && !used_package.includes(index_paket[0])) {

          }
          else if (index_paket[0] == "LIST") {
            same_groups = index_paket[1].join(', ');

          }

        })
        if (index[0].includes("(Group)")) {

          let same_groups_list = same_groups.split(', ');
          same_groups_list = same_groups_list.filter(group => group !== 'REMOVE_THIS');

          let items = [];


          Object.keys(dataSkor).map(index_paket => {
            const paketData = dataSkor[index_paket];
            let user_info = paketData.user_info;
            // Liste içinde eşleşme kontrolü
            if (paketData.user_info?.trt_arabi_unvan && same_groups_list.includes(paketData.user_info?.trt_arabi_unvan)) {
              items.push({
                icon: { color: "info", component: "person", src: window.BASE_URL + "/" + paketData.user_info?.thumbnail },
                label: `${paketData.user_info?.name} ${paketData.user_info?.surname}`,
                variables: {
                  disiplin: `${paketData.disiplin}`,
                  disiplin_deger: `${paketData.disiplin_deger}`,
                  saglik_raporu: `${paketData.saglik_raporu}`,
                  saglik_raporu_deger: `${paketData.saglik_raporu_deger}`,
                  performans: `${paketData.performans}`,
                  performans_deger: `${paketData.performans_deger}`,
                  mesai_uyum: `${paketData.mesai_uyum}`,
                  mesai_uyum_deger: `${paketData.mesai_uyum_deger}`,
                  degerlendirme: `${paketData.degerlendirme}`,
                  degerlendirme_deger: `${paketData.degerlendirme_deger}`,
                  unvan: `${paketData.user_info?.trt_arabi_unvan}`,
                  skor: `${paketData.toplam_skor}`,
                  mudurluk: `${paketData.user_info?.mudurluk}`,

                },

                progress: { content: `${paketData.toplam_skor + "//sa"}` },
              });
            }
          });



          rows.push(
            <Grid item xs={12} md={12} xl={12} mt={2}>
              <ReportsBarChart
                title=""

                description={
                  <>
                    <strong>Aynı Sayılacak Ünvanlar:</strong> {same_groups}

                  </>
                }
                altdesc={""}
                maintitle={`${index[0]}   `}
                chart={{}}

                items={items}

                color="dark"
                size="12"
                xdesc="true"
                filter={selectedMudurluk}
                sort={tabIndex}
                loading={isLoading}

              />

            </Grid>
          )
        }
        else {
          same_ungroups.push(index[1]["NAME"])
          ungroup_count += index[1]["KISI_SAYISI"]
          ungroup_total += index[1]["TOPLAM"]
        }
      })



      items = []




      Object.keys(dataSkor).map(index_paket => {
        const paketData = dataSkor[index_paket];
        // Liste içinde eşleşme kontrolü
        if (paketData.user_info?.trt_arabi_unvan && same_ungroups.includes(paketData.user_info?.trt_arabi_unvan)) {
          items.push({
            icon: { color: "info", component: "person" },
            label: `${paketData.user_info?.name} ${paketData.user_info?.surname}`,
            progress: { content: `${paketData.toplam_skor}` },
            variables: {
              disiplin: `${paketData.disiplin}`,
              disiplin_deger: `${paketData.disiplin_deger}`,
              saglik_raporu: `${paketData.saglik_raporu}`,
              saglik_raporu_deger: `${paketData.saglik_raporu_deger}`,
              performans: `${paketData.performans}`,
              performans_deger: `${paketData.performans_deger}`,
              mesai_uyum: `${paketData.mesai_uyum}`,
              mesai_uyum_deger: `${paketData.mesai_uyum_deger}`,
              degerlendirme: `${paketData.degerlendirme}`,
              degerlendirme_deger: `${paketData.degerlendirme_deger}`,
              unvan: `${paketData.user_info?.trt_arabi_unvan}`,
              skor: `${paketData.toplam_skor}`,
              mudurluk: `${paketData.user_info?.mudurluk}`,

            },
          });
        }
      });

      rows.push(<Grid item xs={12} md={12} xl={12} mt={2}>
        <ReportsBarChart
          title=""

          description={
            <>
              <strong>Ünvan Listesi:</strong> {same_ungroups.join(', ')}

            </>
          }
          altdesc={""}
          maintitle={`Hesaplanmayan Personeller  `}
          chart={{}}

          items={items}

          color="dark"
          size="12"
          xdesc="true"
          filter={selectedMudurluk}
          sort={tabIndex}
          loading={isLoading}

        />
      </Grid>

      )


    }


    return (
      <DashboardLayout>
        {/* <DashboardNavbar /> */}
        <PageHeader data={dataSkor} onChange={onTabChange} />
        <SoftBox
          style={{
            position: "absolute",
            zIndex: 1,
            right: "10%",
            top: "310px",
          }}
          sx={{
            display: { xs: "grid", sm: "flex" }, // Responsive display
          }}
        >


          <SoftButton id="printButton" onClick={yearChangeRemove} sx={{ ml: 2, background: "transparent", gap: "10px" }} color="white">
            <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" color="white">
              open_in_new
            </Icon> ‎ ÖNCEKİ YIL
          </SoftButton>
          <SoftButton id="printButton" onClick={yearChangeAdd} sx={{ ml: 2, background: "transparent" }} color="white">
            <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" color="white">
              open_in_new
            </Icon> ‎ SONRAKİ YIL
          </SoftButton>

        </SoftBox>

        <SoftBox mt={2} mb={3} style={{ marginInline: "3%" }}>
          <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <SoftTypography variant="button" color="text" fontWeight="medium">
              Seçilen {"Müdürlükler "}
            </SoftTypography>
          </SoftBox>
          <Grid mx={0} maxWidth={450}>
            <SoftSelect
              placeholder="Tüm Birimler"
              onChange={(e) => setSelectedMudurluk(e.value)} // Seçimi state'e aktar
              options={[
                { label: "TÜMÜ", value: null }, // "Tümü" seçeneği
                ...uniqueMudurlukler.map(mudurluk => ({
                  label: mudurluk, // Görüntülenecek metin
                  value: mudurluk, // Değer
                }))
              ]}
            />


          </Grid>

        </SoftBox>


        {rows}

      </DashboardLayout>
    );
  }
  catch (error) {
    console.log(error);
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <PermissionNavbar />
      </DashboardLayout>
    );
  }
}

export default Tables;
